import { getAccessToken } from 'cng-common/helpers/access/index'
import { NotificationController } from 'core-components/library/popup'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { IContact } from '../model/types'

import { mapContactFromContactAllData } from './mapping'

export const fetchContactsByPartnerId = async (partnerId: string): Promise<Array<IContact>> => {
  const url = proxy(`/webservice/197/sp/v4/spPartnerContactsByPartner/call`)
  const accessToken = getAccessToken()
  const payload = {
    'p.PartnerID': partnerId,
  }

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return response.Data.map(mapContactFromContactAllData)
  } catch (e) {
    Logger.error('Error fetching contacts:', e)
    NotificationController.showError({
      message: 'An error occurred while fetching contacts. Please try again later.',
    })
    return []
  }
}
